// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3IDd6","overflowing":"ReadFullNote_overflowing__2Yv_Q"};